"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 py-24 bg-background text-foreground">
      <Link href="/" className="font-extrabold text-lg no-underline text-foreground mb-8">
        LastRedirect
      </Link>
      <h6 className="text-[13px] font-extrabold tracking-[0.08em] uppercase text-primary">
        Something went wrong
      </h6>
      <h2 className="mt-2 mb-4 text-[32px] font-extrabold leading-tight tracking-tight">
        This page hit an unexpected error.
      </h2>
      <p className="opacity-75 max-w-[440px] mb-6">
        Try again — if it keeps happening, the issue is on our end, not yours.
      </p>
      <div className="flex gap-3">
        <Button onClick={retry}>Try again</Button>
        <Button asChild variant="outline">
          <Link href="/">Back to LastRedirect</Link>
        </Button>
      </div>
    </div>
  );
}
